<template>
	<div v-if="!isSuccess">
		<div style="background-color: #E18738;height: 179px;text-align: center;">
			<img :src="require('@/assets/img/Report_Theft.png')" style="width: 100px;height: 100px;margin-top: 40px;" />
		</div>
		<div style="padding-top: 13px;">
			<van-form label-width="65px" @submit="submit">
				<van-cell-group inset>
					<van-field v-model="newForm.phone" type="tel" name="phone" :label="$t('msg.phone')"
						:placeholder="$t('msg.phonePlaceholder')"
						:rules="[{ required: true, message: $t('msg.phoneMessage') }]" />
					<van-field v-model="newForm.address" type="textarea" show-word-limit maxlength="50" name="address"
						:label="$t('msg.loseAddress')" :placeholder="$t('msg.loseAddressPlaceholder')"
						:rules="[{ required: true, message: $t('msg.loseAddressMessage') }]" />
				</van-cell-group>
				<div style="margin: 16px;">
					<van-button round block style="background-color: #E18738;" native-type="submit">
						{{ $t("msg.submit") }}
					</van-button>
				</div>
			</van-form>
		</div>
	</div>

	<div v-if="isSuccess" style="margin: 0px;padding: 0px;margin-top: 160px; text-align: center;position: relative;">
		<img :src="require('@/assets/img/success.png')" style="width: 124px;height: 124px;" />
		<div class="center" style="margin-top: 18px; width: 284px;">
			<span style="color: #9095A6; font-size: 18px;">{{ $t("msg.submitPrompt") }}</span>
		</div>
	</div>
</template>

<script>
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";
	import http from '../utils/request.js'
	import api from '../api/index.js'
	export default {
		components: {},

		data() {
			return {
				isSuccess: false,
				newForm: {
					type: 2,
					address: '',
					longitude: '',
					latitude: '',
					phone: '',
					motoId: '',
					deptId: ''
				},

			}
		},
		methods: {
			submit() {
				api.systemServiceApi.createRepair(this.newForm)
					.then((result) => {
						if (result != null) {
							// 弹出成功提示
							this.$Message.success(this.$t('msg.submitSuccess'));
							this.isSuccess = true;
						}
					});
			},
		},
		mounted() {
			this.newForm.motoId = this.$route.query.motoId;
			this.newForm.deptId = this.$route.query.deptId;
			this.newForm.address = this.$route.query.address;
			this.newForm.longitude = this.$route.query.lon;
			this.newForm.latitude = this.$route.query.lat;


			// var lang = this.$route.query.lang;
			// if(lang != null){
			//     const store = useStore();
			//     const i18n = useI18n();
			//     i18n.locale.value = lang;
			//     store.commit("setLanguage", lang);
			// }

			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.reportOfTheft')
		}
	}
</script>

<style>
	.center {
		text-align: center;
		position: absolute;
		left: 50%;
		transform: translate(-50%);
	}
</style>